import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronLeft16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m6.81 8 3.47-3.47-1.06-1.06L4.69 8l4.53 4.53 1.06-1.06z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconChevronLeft16);
export default ForwardRef;
